<template>
    <div>
        <DCard padding>
            <DTable
                id="clarifications-table"
                :fields="fields"
                :items="checks"
            >
                <template #field="{item}">
                    <td>
                        {{ __('orders.check.automatic_checks_tab.fields.'+item.field) }}
                    </td>
                </template>
                <template #status="{item}">
                    <td>
                        <DIcon
                            v-if="item.solved === true"
                            :id="`check_circle_${item.field}`"
                            name="check-circle"
                            :size="18"
                            class="color-green"
                        />
                        <DIcon
                            v-else
                            :id="`minus_circle_${item.field}`"
                            name="minus-circle"
                            :size="18"
                            class="color-red"
                        />
                    </td>
                </template>
                <template #name="{item}">
                    <td>
                        {{ item.order_manual_check_setting.name }}
                    </td>
                </template>
                <template #text="{item}">
                    <td>
                        {{ item.order_manual_check_setting.text }}
                    </td>
                </template>
                <template #solution_instruction="{item}">
                    <td>
                        {{ item.order_manual_check_setting.solution_instruction }}
                    </td>
                </template>
                <template #actions="{item}">
                    <td>
                        <DButton
                            :id="`edit_${item.field}`"
                            mini
                            icon="chat-processing-outline"
                            @click="openClarificationModal(item)"
                        />
                    </td>
                </template>
            </DTable>
        </DCard>
        <DFabs>
            <CheckButtons>
                <template #additional_buttons>
                    <DFab
                        v-if="(data.status === 'clarification_external' || data.status === 'clarification_internal') && userPermissions.includes('order.view')"
                        id="btn-reject"
                        :disabled="isInLoadingState"
                        icon="replay"
                        :label="__('orders.check.clarifications_tab.back_to_screening')"
                        @click="showBackToScreeningModal()"
                    />
                </template>
            </CheckButtons>
        </DFabs>
        <ClarificationChatModal
            v-if="showClarificationChatModal"
            :item="selectedItem"
            :check-id="selectedItem.id"
            :order="data"
            :show-modal="showClarificationChatModal"
            @close-modal="closeReasonModal"
        />
        <OrderCommentModal
            v-if="showOrderCommentModal"
            :action="action"
            :title="orderCommentModalTitle"
            :order="data"
            :comment-required="commentRequired"
            :show-modal="showOrderCommentModal"
            @close-modal="closeCommentModal"
        />
    </div>
</template>

<script>
import OrderBase from '~@/Pages/Orders/Psa/Checks/Base'
import App from '~@/App.vue'
import ClarificationChatModal from '~@/Components/Orders/Psa/ClarificationChatModal.vue'
import OrderCommentModal from '~@/Components/Orders/Psa/OrderCommentModal'
import CheckButtons from '~@/Components/Orders/CheckButtons'

export default {
    name: 'Clarifications',
    components: { OrderCommentModal, ClarificationChatModal, CheckButtons },
    layout: [App, OrderBase],
    props: {
        data: {
            type: Object,
            default: () => { return {} }
        },
        checks: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            fields: [
                { key: 'status', label: this.__('orders.check.clarifications_tab.status'), sorter: false },
                { key: 'name', label: this.__('orders.check.clarifications_tab.name'), sorter: false },
                { key: 'text', label: this.__('orders.check.clarifications_tab.text'), sorter: false },
                { key: 'solution_instruction', label: this.__('orders.check.clarifications_tab.solution_instruction'), sorter: false },
                { key: 'actions', label: '', sorter: false }
            ],
            showClarificationChatModal: false,
            selectedItem: null,
            showOrderCommentModal: false,
            orderCommentModalTitle: false,
            action: null,
            commentRequired: true,
            clarificationTitle: null
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        openClarificationModal (item) {
            this.showClarificationChatModal = true
            this.selectedItem = {
                id: item.id,
                name: item.order_manual_check_setting.name,
                text: item.order_manual_check_setting.text,
                solution_instruction: item.order_manual_check_setting.solution_instruction,
                comment: item.comment,
                solution_proposal: item.solution_proposal,
                final_solution: item.final_solution,
                comments: item.comments,
                solved: item.solved
            }
        },
        closeReasonModal () {
            this.showClarificationChatModal = false
            this.selectedItem = null
        },
        showBackToScreeningModal () {
            this.showOrderCommentModal = true
            this.commentRequired = false
            this.action = 'clarification_back_to_screening'
            this.orderCommentModalTitle = this.__('orders.check.clarifications_tab.back_to_screening')
        },
        closeCommentModal () {
            this.showOrderCommentModal = false
            this.action = null
            this.orderCommentModalTitle = null
        }
    }
}
</script>

<style scoped>
.color-green {
    color: green;
}
.color-red {
    color: red;
}
.disabled-button {
    cursor: not-allowed !important;
}
</style>
